import {ErrorMsg} from '@shared/core';

const errorMessages = {
  400: 'This time is already taken, choose another',
};

export function isTimeOccupied(response: any): response is ErrorMsg {
  return (
    'statusErr' in response && 'payload' in response && response.payload?.detail === errorMessages[response.statusErr]
  );
}
